export const OE_PANEL_TXT = 'Onboarding Engine Panel';
export const VIEW_DOCUMENTS_WIN_BLOCKED_MSG =
  'The popup was blocked. You must allow popups to use this site.';
export const TRANSPORT_LABEL = 'Transport';
export const AUTHORIZED_SIGNATORY_EXIST = 'User already added as a signatory!';
export const LEAD_SAVED_MSG = 'Lead saved successfully.';
export const ERROR_RESPONSE_MESSAGE =
  'Oops! something went wrong. Please contact the administrator.';
export const NETWORK_ERROR_RESPONSE_MESSAGE =
  'Your network seems to be down. Please connect to network and try again.';
export const NETWORK_ERROR_TEXT = 'network error';
export const GO_HOME = 'Go to Home';
export const PERMISSION_ERROR = 'Permissions Error!';
export const PERMISSION_ERROR_MESSAGE =
  'We are unable to identify permissions assigned to you on this panel. Please contact "ggaccess@paytm.com" to ensure correct permissions. Logging you out. . .';
export const SAVE_BTN_LABEL = 'Save';
export const REALLOCATE_BTN_LABEL = 'Reallocate';
export const RE_BOOKAPPOINTMENT_BTN_LABEL = 'Re-book Appointment';
export const FRESH_DE_REQ_BTN_LABEL = 'Fresh DE Reqd.';
export const UPLOAD_BTN_LABEL = 'Upload';
export const SUBMIT_BTN_LABEL = 'Submit';
export const CONTINUE_BTN_LABEL = 'Continue';
export const BACK_BTN_LABEL = 'Back';
export const VIEW_BTN_LABEL = 'View';
export const EDIT_MODE_KEY = 'EDIT';
export const VIEW_MODE_KEY = 'VIEW';
export const NEW_BUSINESS_OFFERING_BTN_LABEL = 'Create New Business Offering';
export const COLLAPSE_ALL = 'Collapse All';
export const EXPAND_ALL = 'Expand All';
export const VIEW_DOCUMENT_LABEL = 'View Document';
export const DOCUMENT_LABEL = 'Document(s)';
export const REJECTIONS_REASONS_LABEL = 'Rejection Reason(s)';
export const UPLOAD_DOCUMENT_LABEL = 'Upload Document(s)';
export const VIEW_ALL_DOCUMENT_LABEL = 'View Document(s)';
export const ADD_USER_LABEL = 'Add User';
export const EDIT_BTN_LABEL = 'Edit';
export const ADD_BTN_LABEL = 'Add';
export const OK_BTN_LABEL = 'Ok';
export const UPDATE_BTN_LABEL = 'Update';
export const DELETE_BTN_LABEL = 'Delete';
export const DOWNLOAD_RESULT_BTN_LABEL = 'Download Search Result(s)';
export const DOWNLOAD_LEAD_DETAILS_BTN_LABEL = 'Download Lead Details';
export const DOWNLOAD_SAP_DETAILS_BTN_LABEL = 'Download Sap Lead Details';
export const COMPLETE_BUSINESS_PROFILE_BTN_LABEL = 'Complete Business Profile';
export const CANCEL_BTN_LABEL = 'Cancel';
export const SEARCH_BTN_LABEL = 'Search';
export const PROCEED_BTN_LABEL = 'Proceed';
export const APPLY_BTN_LABEL = 'Apply';
export const RESET_BTN_LABEL = 'Reset';
export const FILTER_BTN_LABEL = 'Filter';
export const ALLOCATE_BTN_LABEL = 'Allocate';
export const APPROVE_ALL_BTN_LABEL = 'Approve All';
export const NOPAGE_FOUND_ERROR_MESSAGE =
  "We can't find the page you're looking for.";
export const NAME_LABEL = 'Name';
export const EMAIL_LABEL = 'Email';
export const MOBILE_LABEL = 'Mobile';
export const DEPARTMENT_LABEL = 'Department';
export const SIGN_OUT_LINK_LABEL = 'Sign out';
export const PRIVACY_LABEL = 'Privacy';
export const LEGAL_LABEL = 'Legal';
export const ABOUT_US_LABEL = 'About Us';
export const BLOG_LABEL = 'Blog';
export const TNC_LABEL = 'Terms & Conditions';
export const ALLOCATE_AGENT_TEXT = 'Allocate Agent';
export const MERCHANT_CUST_ID_LABEL = 'Merchant Cust ID';
export const MERCHANT_MOBILE_NUM_LABLE = 'Merchant Mobile No';
export const AGENT_ID = 'Agent ID';
export const AGENT_CUST_ID_LABEL = 'Agent Cust ID';
export const AGENT_NAME_LABEL = 'Agent Name';
export const AGENT_EMAIL_LABEL = 'Agent Email';
export const AGENT_MOBILE_NUM_LABEL = 'Agent Mobile No';
export const MOBILE_NUM_LABEL = 'Mobile No';
export const SELECTED_MERCHANT_TEXT = 'Selected Merchant(s)';
export const SELECTED_AGENT_DETAILS_TEXT = 'Selected Agent Details';
export const LEADS_TEXT = 'Leads';
export const SEARCH_LEADS_TEXT = 'Advanced Leads';
export const LEADS_STATUS_TEXT = 'Lead Status';
export const FILE_UPLOAD_TEXT = 'File Upload';
export const ASYNC_FILE_UPLOAD_TEXT = 'Async File Upload';
export const PPB_LEADS_TEXT = 'PPB Leads';
export const CA_LEADS_TEXT = 'CA Leads';
export const DOWNLOAD_CA_DOCUMENTS_TEXT = 'Download CA Documents';
export const MANAGE_AGENCY_TEXT = 'Manage Agency';
export const UPDATE_AGENT_TEXT = 'Manage Agents';
export const KAM_WORKFLOW = 'KAM Flow';
export const BUSINESS_ONBOARDING_TEXT = 'Business Onboarding';
export const ACCOUNTS = 'Accounts';
export const SUMMARY_TEXT = 'Summary';
export const JOB_REPLAY = 'Job Replay';
export const FILE_UPLOAD_SAMPLE_FILE_LABEL = 'Sample File';
export const FILE_UPLOAD_OPTION_LABEL = 'Upload file for';
export const FILE_UPLOAD_SIZE_ERROR_MSG = (maxFileSize) =>
  `The file you are trying to upload is larger than ${maxFileSize} MB and cannot be uploaded. Please reduce the size of the file and try again.`;
export const FILE_UPLOAD_TYPE_ERROR_MSG =
  'The file you are trying to upload is not a supported file format. Please try again.';
export const FILE_UPLOAD_LINK_LABEL = 'Add file from this computer';
export const SEARCH_BY_LABEL = 'Search By';
export const SEARCH_TEXT_LABEL = 'Search Text';
export const SOLUTION_TYPE_LABEL = 'Solution Type';
export const SOLUTION_SUBTYPE_LABEL = 'Solution Sub-Type';
export const CATEGORY_LABEL = 'Category';
export const SUB_CATEGORY_LABEL = 'Sub-Category';
export const FROM_CREATED_DATE_LABEL = 'Created Date (From)';
export const CREATED_DATE_LABEL = 'Created Date';
export const LAST_UPDATED_LABEL = 'Last Updated';
export const TO_CREATED_DATE_LABEL = 'Created Date (To)';
export const SUB_STAGE_LABEL = 'Sub Stage';
export const PREVIOUS_SUB_STAGE_LABEL = 'Previous Substage';
export const STAGE_LABEL = 'Stage';
export const ASSIGNED_TO_TEXT = 'Assigned To';
export const VERIFICATION_AGENT_LABEL = 'Verification Agent';
export const MANAGE_LEADS_TEXT = 'Manage Lead(s)';
export const STATE_LABEL = 'State';
export const COUNT_LABEL = 'Count';
export const MAX_RECORD_DOWNLOAD_LIMIT = 'Max 1000 records allowed';
export const MANAGE_PPB_LEADS_TEXT = 'Manage PPB Lead(s)';
export const MANAGE_CA_LEADS_TEXT = 'Manage CA Lead(s)';
export const LEAD_ID_TEXT = 'Lead ID';
export const BUSINESS_NAME_TEXT = 'Business Name';
export const PAN_TEXT = 'PAN';
export const MOBILE_TEXT = 'Mobile Number';
export const ENTITY_TEXT = 'Entity Type';
export const SUMMARY_PAGE_TEXT = 'Summary Page';
export const SELECT_START_DATE_LABEL = 'Select Start Date';
export const SELECT_END_DATE_LABEL = 'Select End Date';
export const CREATE_BUSINESS_LABEL = "Enter Applicant's Mobile Number";
export const BUSINESS_LIST_LABEL = 'Business List';
export const CREATE_LEAD = 'Create Lead';
export const CREATE_KYC_LEAD = 'Create KYC Lead';
export const BUSINESSES_LABEL = 'Businesses';
export const BUSINESS_PROFILE_LABEL = 'Business Profile';
export const AVAILED_SOLUTIONS_LABEL = 'Availed/In-Progress Solutions';
export const APPLIED_FOR_LABEL = 'Apply For';
export const APPLIED_FOR_DETAILS_LABEL = 'Apply For Details';
export const CLICK_HERE_LABEL = 'Click Here';
export const ADD_NEW_BUSINESS_LABEL = 'Add Business Details';
export const UPDATE_NEW_BUSINESS_LABEL = 'Update Business Details';
export const NSDL_LABEL = 'Name as per NSDL';
export const PAN_NUMBER = 'PAN Number';
export const PREQUOTES_LABEL = 'Apply';
export const PREMIUM_LABEL = 'Premium';
export const FETCH_QUOTES_LABEL = 'Fetching Quotes...';
export const REPORTING = 'Reporting';
export const REPORTING_PAGE_TITLE = 'Reports List';
export const CHANNEL = 'Channel';
export const ENTITY_TYPE = 'Entity Type';
export const AGENT_TYPE = 'Agent Type';
export const AGENT_GROUP = 'Agent Group';
export const PANEL_CUST_ID = 'Panel Cust ID';
export const CREATOR_CUST_ID = 'Creator Cust ID';
export const ADD_RESEND_BTN_LABEL = 'Add & Resend';
export const BUSINESS_NAME = 'Business Name';
export const DISPLAY_NAME = 'Display Name';
export const VIEW_AUDIT_TRAIL_DETAILS = 'View Audit Trail Details';
export const DOWNLOAD_BTN_LABEL = 'Download';
export const PERIOD_OF_DISBURSEMENT_OVRELAP_MSG =
  'Overlapping Period of Disbursement entered.';
export const FILE_NAME = 'File Name';
export const FILE_STATUS_MESSAGE = 'Status Message';
export const FILE_STATUS_TOTAL_COUNT = 'Total Count';
export const FILE_STATUS_SUCCESS_COUNT = 'Success Count';
export const FILE_STATUS_FAILURE_COUNT = 'Failure Count';
export const FILE_STATUS_UPLOADED_AT = 'Uploaded At';
export const FILE_STATUS_UPLOADED_BY = 'Uploaded By';
export const FILE_STATUS = 'Status';
export const PROCESS_NAME = 'Process Name';
export const DOWNLOAD_KYC_DOCUMENTS = 'Download KYC Documents';
export const REPORT_DOWNLOADS = 'Report Downloads';
export const KYC_LEADS_TEXT = 'KYC Leads';
export const KYC_REPORT_TEXT = 'Reports';
export const START_DATE = 'Start Date';
export const END_DATE = 'End Date';
export const COMMENTS = 'Comments';
export const REPORT_TYPE_TEXT = 'Report Type';
export const REASON_TEXT = 'Reason';
export const ENTER_REASON_HINT_TEXT = 'Please enter your reason';
export const AGENCY_NAME_LABEL = 'Agency Name';
export const CUST_ID_LABEL = 'Cust ID';
export const DOC_PROVIDED_CONFIRMATION =
  'Are you sure to change Document Type?';
export const UPLOAD_DOCS = 'Upload Documents';
export const DEAL_OPERATION = 'Deal Operation';
export const FSM = 'FSE Management System';
export const VENDOR_CODE = 'Vendor Code';
export const BANKING_MODULE = 'Banking Module';
export const PAYMENTS = 'Payment Details';
export const GET_DETAILS = 'Get Details';
export const VERIFY_OTP = 'Verify OTP';
export const ENTER_OTP = 'Enter OTP';
export const CHECK_PAYMENT_STATUS = 'Check Payment Status';
export const SEND_NOTIFICATION = 'Send Notification';
export const RESEND_OTP = 'Resend Otp';
export const SOLUTION_TYPE_LEVEL3 = 'Solution Type Level3';
export const SOLUTION_KEY = 'Solution Key';
export const FINISH_MAPPING = 'Finish Mapping Request';
export const DOWNLOAD_BTN_ZIP_LABEL = 'Download Zip';
export const UAD = 'UAD Update';
export const ADMIN_UTILITY = 'Admin Utilities';
export const PINCODE_LABEL = 'Pincode';
export const ZONE_LABEL = 'Zone';
export const ZONEID_LABEL = 'Zone Id';
export const STATEID_LABEL = 'State Id';
export const ISTIER3DISTRICT_LABEL = 'Is Tier 3 District';
export const TIER3_LABEL = 'Tier 3 Value';
export const TIER3ID_LABEL = 'Tier 3 Id';
export const ISAREA_LABEL = 'Is Area';
export const TIER4_LABEL = 'Tier 4 Value';
export const TIER4ID_LABEL = 'Tier 4 Id';
export const TEAM_LEAD = 'TL';

// export default OECONSTANTS;
